<nav class="navbar">
  <!-- Logo a sinistra -->
  <div class="navbar-logo">
    <a href="/" [title]="'Home'" aria-label="Home">
      <img src="img/logo-bertani-color.svg" alt="Logo Merci Bertani" height="35px" loading="eager" fetchpriority="high">
    </a>
  </div>
  <!--  <div class="navbar-logo snow-container">
        <a href="/" title="Home" aria-label="Home">
            <img
                    src="img/logo-bertani-color-winter.svg"
                    alt="Logo Merci Bertani"
                    height="35"
                    class="logo-img">
            <canvas class="snow-canvas"></canvas>
        </a>
    </div> -->
  <!-- Importa la libreria Font Awesome da URL -->
  <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" rel="stylesheet">
  
  <!-- Pulsanti a destra visibili su desktop -->
  <div class="navbar-buttons desktop-menu">
    <!-- Menu a tendina per le lingue -->
    <!-- <div class="dropdown">
      <button class="btn btn-language dropdown-toggle" type="button" id="languageDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="fas fa-globe"></i> <span>{{ 'NAVBAR.LANGUAGE' | translate }}</span>
      </button>
      <div class="dropdown-menu dropdown-menu-end language-dropdown" aria-labelledby="languageDropdown">
        <div class="language-grid">
          <a class="dropdown-item" (click)="changeLanguage('it')"><span class="fi fi-it flag-icon"></span> Italiano</a>
          <a class="dropdown-item" (click)="changeLanguage('en')"><span class="fi fi-gb flag-icon"></span> English</a>
          <a class="dropdown-item" (click)="changeLanguage('fr')"><span class="fi fi-fr flag-icon"></span> Français</a>
          <a class="dropdown-item" (click)="changeLanguage('de')"><span class="fi fi-de flag-icon"></span> Deutsch</a>
          <a class="dropdown-item" (click)="changeLanguage('es')"><span class="fi fi-es flag-icon"></span> Español</a>
          <a class="dropdown-item" (click)="changeLanguage('pt')"><span class="fi fi-pt flag-icon"></span> Português</a>
          <a class="dropdown-item" (click)="changeLanguage('nl')"><span class="fi fi-nl flag-icon"></span> Nederlands</a>
          
          <a class="dropdown-item" (click)="changeLanguage('pl')"><span class="fi fi-pl flag-icon"></span> Polski</a>
          <a class="dropdown-item" (click)="changeLanguage('uk')"><span class="fi fi-ua flag-icon"></span> Українська</a>
          <a class="dropdown-item" (click)="changeLanguage('ro')"><span class="fi fi-ro flag-icon"></span> Română</a>
          <a class="dropdown-item" (click)="changeLanguage('sq')"><span class="fi fi-al flag-icon"></span> Shqip</a>
          <a class="dropdown-item" (click)="changeLanguage('tr')"><span class="fi fi-tr flag-icon"></span> Türkçe</a>
          <a class="dropdown-item" (click)="changeLanguage('ru')"><span class="fi fi-ru flag-icon"></span> Русский</a>
          <a class="dropdown-item" (click)="changeLanguage('ar')"><span class="fi fi-sa flag-icon"></span> العربية</a>
          
          <a class="dropdown-item" (click)="changeLanguage('fa')"><span class="fi fi-ir flag-icon"></span> فارسی</a>
          <a class="dropdown-item" (click)="changeLanguage('am')"><span class="fi fi-et flag-icon"></span> አማርኛ</a>
          <a class="dropdown-item" (click)="changeLanguage('hi')"><span class="fi fi-in flag-icon"></span> हिन्दी</a>
          <a class="dropdown-item" (click)="changeLanguage('bn')"><span class="fi fi-bd flag-icon"></span> বাংলা</a>
          <a class="dropdown-item" (click)="changeLanguage('ur')"><span class="fi fi-pk flag-icon"></span> اردو</a>
          <a class="dropdown-item" (click)="changeLanguage('zh')"><span class="fi fi-cn flag-icon"></span> 中文</a>
          <a class="dropdown-item" (click)="changeLanguage('jp')"><span class="fi fi-jp flag-icon"></span> 日本語</a>
        </div>
      </div>
    </div> -->
    <a href="/tracking" class="btn btn-tracking"><i class="fas fa-map-marker-alt"></i> <span>{{ 'NAVBAR.TRACKING' | translate }}</span></a>
    <a href="/login" class="btn login-button"><i class="fas fa-sign-in-alt"></i> <span>{{ 'NAVBAR.LOGIN' | translate }}</span></a>
  </div>
  
  <!-- Burger menu per mobile -->
  <button class="mobile-menu-toggle" (click)="toggleMobileMenu()" aria-label="Toggle Menu">
    <i class="fas fa-bars"></i>
  </button>
</nav>

<!-- Menu mobile sotto la navbar -->
<div class="mobile-menu-container" [class.active]="mobileMenuOpen">
  <div class="mobile-menu-content">
    <!-- Lingua -->
    <div class="mobile-menu-section">
      <div class="section-title">
        <i class="fas fa-globe"></i> {{ 'NAVBAR.LANGUAGE' | translate }}
      </div>
      <div class="language-grid-mobile">
        <a class="mobile-menu-item" (click)="changeLanguage('it'); closeMobileMenu()"><span class="fi fi-it flag-icon"></span> Italiano</a>
        <a class="mobile-menu-item" (click)="changeLanguage('en'); closeMobileMenu()"><span class="fi fi-gb flag-icon"></span> English</a>
        <!-- <a class="mobile-menu-item" (click)="changeLanguage('fr'); closeMobileMenu()"><span class="fi fi-fr flag-icon"></span> Français</a>
        <a class="mobile-menu-item" (click)="changeLanguage('de'); closeMobileMenu()"><span class="fi fi-de flag-icon"></span> Deutsch</a>
        <a class="mobile-menu-item" (click)="changeLanguage('es'); closeMobileMenu()"><span class="fi fi-es flag-icon"></span> Español</a>
        <a class="mobile-menu-item" (click)="changeLanguage('pt'); closeMobileMenu()"><span class="fi fi-pt flag-icon"></span> Português</a> -->
        <!-- Aggiungi altre lingue se necessario -->
        <!-- <a class="mobile-menu-item show-all-languages" (click)="showAllLanguages = !showAllLanguages">
          {{ showAllLanguages ? 'Nascondi altre lingue' : 'Mostra altre lingue' }}
          <i class="fas" [class.fa-angle-down]="!showAllLanguages" [class.fa-angle-up]="showAllLanguages"></i>
        </a>
      </div>
      <div class="all-languages" *ngIf="showAllLanguages">
        <div class="language-grid-mobile">
          <a class="mobile-menu-item" (click)="changeLanguage('nl'); closeMobileMenu()"><span class="fi fi-nl flag-icon"></span> Nederlands</a>
          <a class="mobile-menu-item" (click)="changeLanguage('pl'); closeMobileMenu()"><span class="fi fi-pl flag-icon"></span> Polski</a>
          <a class="mobile-menu-item" (click)="changeLanguage('uk'); closeMobileMenu()"><span class="fi fi-ua flag-icon"></span> Українська</a>
          <a class="mobile-menu-item" (click)="changeLanguage('ro'); closeMobileMenu()"><span class="fi fi-ro flag-icon"></span> Română</a>
          <a class="mobile-menu-item" (click)="changeLanguage('sq'); closeMobileMenu()"><span class="fi fi-al flag-icon"></span> Shqip</a>
          <a class="mobile-menu-item" (click)="changeLanguage('tr'); closeMobileMenu()"><span class="fi fi-tr flag-icon"></span> Türkçe</a>
          <a class="mobile-menu-item" (click)="changeLanguage('ru'); closeMobileMenu()"><span class="fi fi-ru flag-icon"></span> Русский</a>
          <a class="mobile-menu-item" (click)="changeLanguage('ar'); closeMobileMenu()"><span class="fi fi-sa flag-icon"></span> العربية</a>
          <a class="mobile-menu-item" (click)="changeLanguage('fa'); closeMobileMenu()"><span class="fi fi-ir flag-icon"></span> فارسی</a>
          <a class="mobile-menu-item" (click)="changeLanguage('am'); closeMobileMenu()"><span class="fi fi-et flag-icon"></span> አማርኛ</a>
          <a class="mobile-menu-item" (click)="changeLanguage('hi'); closeMobileMenu()"><span class="fi fi-in flag-icon"></span> हिन्दी</a>
          <a class="mobile-menu-item" (click)="changeLanguage('bn'); closeMobileMenu()"><span class="fi fi-bd flag-icon"></span> বাংলা</a>
          <a class="mobile-menu-item" (click)="changeLanguage('ur'); closeMobileMenu()"><span class="fi fi-pk flag-icon"></span> اردو</a>
          <a class="mobile-menu-item" (click)="changeLanguage('zh'); closeMobileMenu()"><span class="fi fi-cn flag-icon"></span> 中文</a>
          <a class="mobile-menu-item" (click)="changeLanguage('jp'); closeMobileMenu()"><span class="fi fi-jp flag-icon"></span> 日本語</a>
        </div>
      </div> -->
    </div>
    
    <!-- Link di navigazione -->
    <div class="mobile-menu-section">
      <div class="section-title">
        <i class="fas fa-bars"></i> Menu
      </div>
      <div class="mobile-menu-items">
        <a href="/tracking" class="mobile-menu-button" (click)="closeMobileMenu()">
          <div class="menu-item-icon">
            <i class="fas fa-map-marker-alt"></i>
          </div>
          <div class="menu-item-content">
            {{ 'NAVBAR.TRACKING' | translate }}
          </div>
        </a>
        <a href="/login" class="mobile-menu-button login-button-mobile" (click)="closeMobileMenu()">
          <div class="menu-item-icon">
            <i class="fas fa-sign-in-alt"></i>
          </div>
          <div class="menu-item-content">
            {{ 'NAVBAR.LOGIN' | translate }}
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
</div>